import React from "react";
import { Link } from "react-router-dom"; 

export default function CaseStudy() {
  return (
    <section className="relative ">
      <img
        src="/uploads/Assets/casestudy.webp"
        className="absolute inset-0 h-full w-full object-cover z-0"
        alt="background-image"
      />
      <div className="relative z-10 grid grid-cols-1 gap-4 xl-custom:grid-cols-12 mx-auto max-w-6xl px-4 p-14 sm:px-6">
        
        <div className="w-full py-8 text-white text-left order-2 xl-custom:order-1 col-span-1 xl-custom:col-span-5">
          <h2 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px]">Case Study</h2>
          <p className="mt-2 text-current font-uber text-[16px] font-normal leading-[24px]">
            Dive into real-world campaigns where playables transformed brand goals into measurable success.
          </p>
          <Link 
            to="/case-study"
            className="mt-4 xl-custom:mt-8 px-6 py-2 bg-white text-black rounded active:bg-gray-700 active:text-white text-[16px] font-uber font-medium inline-block"
          >
            Read More
          </Link>
        </div>
        
        <div className="w-full flex justify-center order-1 xl-custom:order-2 col-span-1 xl-custom:col-start-7 xl-custom:col-span-6">
          <img
            src="/uploads/Assets/Asset1.webp"
            alt="asset1"
          />
        </div>
      </div>
    </section>
  );
}